import { registerChatUITranslations } from '@trimble-agentic-internal-npm-local/agentic-chat-ui';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';

const initializeI18n = () => {
  i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations,
      },
    },
  });

  registerChatUITranslations(i18n);
};

initializeI18n();

export default i18n;
